import axios from 'axios';
import { getBaseUrlAnalista, getBaseUrlSolicitante, ensureProtocol } from '../config/backend';

export function getStatusChamadoConfig(isSolicitante) {
  if (isSolicitante) {
    const base = getBaseUrlSolicitante() || ensureProtocol(localStorage.getItem('ipBackend') || '');
    return base ? { baseUrl: base, path: '/api/statusChamado' } : { baseUrl: '', path: '' };
  }
  const base = getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
  return base ? { baseUrl: base, path: '/status-chamado/ativos' } : { baseUrl: '', path: '' };
}

export async function fetchStatusChamado(isSolicitante = false) {
  const { baseUrl, path } = getStatusChamadoConfig(isSolicitante);
  if (!baseUrl || !path) return [];
  const token = localStorage.getItem('token');
  try {
    const res = await axios.get(baseUrl + path, {
      headers: token ? { Authorization: token } : {},
      timeout: 10000
    });
    const raw = res?.data;
    return Array.isArray(raw) ? raw : [];
  } catch (err) {
    console.error('Erro ao carregar status de chamado:', err);
    return [];
  }
}

export function getNomeStatus(statusList, statusVal) {
  if (!Array.isArray(statusList) || statusList.length === 0) return 'Sem definição';
  const n = statusVal != null && statusVal !== '' ? Number(statusVal) : NaN;
  if (Number.isNaN(n)) return 'Sem definição';
  const s = statusList.find((x) => x.codigo_legado === n || x.id === n);
  return s?.nome ?? 'Sem definição';
}

export function isStatusChamadoFechado(statusList, statusVal) {
  if (!Array.isArray(statusList) || statusList.length === 0) return false;
  const n = statusVal != null && statusVal !== '' ? Number(statusVal) : NaN;
  if (Number.isNaN(n)) return false;
  const s = statusList.find((x) => Number(x.codigo_legado) === n || Number(x.id) === n);
  if (!s) return false;
  return Number(s.finalizacao ?? s.FINALIZACAO) === 1
    || Number(s.conclusao ?? s.CONCLUSAO) === 1
    || Number(s.cancelamento ?? s.CANCELAMENTO) === 1;
}
